/* globals jQuery, Class, Port, _, windowLoaded */


/*
	This is a developer interface for Port.
	It can also be put on a submarine to see out of.

	outside == insecure outside origin
	inside == secure, inside-of-an-iframe origin
*/

// Check if the window loaded
// Some shit will rely on that for initting ports
window.windowLoaded = false;
jQuery(() => {
	window.windowLoaded = true;
});

window.PortHole = Class.create({
	initialize: function(config) {
		return;

		/* config:
			origin ('inside'|'outside') -- whether you're inside the porthole or
			outside
			name (str) -- the porthole's name; 'inside' and 'outside' must use
			the same name
			on_ready (func) -- a function to handle when the porthole is ready
			on_message (func) -- a function to handle when this side gets a
			message (a string)

			iframe_name (str) -- If you're on the OUTSIDE, give the name
			attribute of the iframe


			NOTE: because of JS caching this MUST be sourced from HTML through
			a function call
			secure_prefix -- if you're on the outside
			insecure_prefix -- if you're on the inside
		*/

		this.name = config.name;
		this.channel = `${this.name}_channel`;

		// inside/outside
		this.inside = (config.origin && config.origin === "inside");
		this.outside = !this.inside;

		// callback functions
		this.on_message = config.on_message;


		// if you're on the inside, you must provide the insecure_prefix to talk to.
		if (this.inside && config.insecure_prefix) {
			this.iframe_name = false;
			this.prefix = config.insecure_prefix;
			this.proxy = `${this.prefix}/password_shadowbox_proxy_insecure`;
		}

		// likewise: if you're outside, give us the secure_prefix.
		// AND, give the name of the iframe.
		else if (this.outside && config.secure_prefix) {
			this.iframe_name = config.iframe_name;
			this.prefix = config.secure_prefix;
			this.proxy = `${this.prefix}/password_shadowbox_proxy_secure`;
		}
		console.log("porthole init callback function", this.on_message);

		this.socket = new Port.socket({
			name: this.iframe_name,
			origin: this.prefix,
			proxy: this.proxy,
			channel: this.channel,
			callback: this.on_message,
		});
	},
	send: function(message) {
		if (typeof (message) !== "string") {
			message = JSON.stringify(message);
		}
		this.socket.send(message);
	},
});

/*
	Interface for cross-domain iframe communication.

	If available, Port will use postMessage.
	developer.mozilla.org/en/DOM/window.postMessage

	Otherwise, Port will programatically create
	an iframe to an HTML file located on each domain.
	This is our proxy, and messaging is possible
	because of a security loophole which allows iframes
	on the same domain to read out the src attribute
	of any other iframe on the page.

	Let's assume A wishes to send a message to B.
	A and B are on different domains. To achieve this,
	A will first create an iframe to a page hosted on
	domain B. Then to pass a message A will reset the
	src attribute to the same url, but with its message
	encoded in the hash. Finally A will trigger the resize
	event inside of the proxy by changing its dimensions.

	Each proxy has a function bound to the resize event.
	When triggered, this function will get a reference to
	the recipient, and pass along the decoded message.

	See Port.proxy class below for more documentation.

	@constructor Port.socket
	@param {object} config
	| @param {string} name, name attribute of target iframe
	| @param {string} origin, domain of target iframe
	| @param {string} proxy, full path to proxy on domain of target iframe
	| @param {string} channel, define a messaging namespace
	| @param {function} callback, function to receive messages
*/

window.Port = {};

Port.socket = function (config) {
	console.log("new port socket", config);

	if (!(this instanceof Port.socket)) {
		return new Port.socket(config);
	}

	/* @private */

	let name = config.name ? config.name : "",
		origin = config.origin ? config.origin : "",
		proxy = config.proxy ? config.proxy : "",
		channel = config.channel ? config.channel : "global",
		callback = config.callback ? config.callback : "";

	let has_postMessage = Port.detect.postMessage(),
		log = function (/* or, ch, mes */) {
		};

	/* @public */

	let base,
		modern,
		legacy;

	base = {
		origin: `${window.location.protocol}//${window.location.host}`,
		receive: function (message) {
			message = message.originalEvent;
			console.log("socket receive", message);
			let response;
			if (message.origin === origin) {
				try {
					response = JSON.parse(message.data);
				} catch (error) {
					log(message.origin, channel, error);
				}
				if (response && response.channel === channel) {
					if (typeof callback === "function") {
						callback(response.message);
					}
					log(message.origin, response.channel, response.message);
				}
			}
		},
	};

	modern = {
		init: function () {
			jQuery(window).on("message", this.receive.bind(this));
			log(this.origin, channel, "Modern support enabled");
			this.target_window = this.get_target_window();
			if (!name) {
				if (windowLoaded) {
					this.send("Socket ready");
				} else {
					jQuery(this.send.bind(this, "Socket ready"));
				}
			}
		},
		send: function (message) {
			console.log("socket send", message);
			const json = this.serialize(message);
			this.target_window.postMessage(json, origin);
		},
		serialize: function (message) {
			return JSON.stringify({ message: message, channel: channel });
		},
		get_target_window: function () {
			return name ? window[name] : window.top;
		},
	};

	legacy = {
		init: function () {
			Port.proxy.listeners.push(this.receive.bind(this));
			log(this.origin, channel, "Legacy support enabled");
			this.target_window = this.get_target_window();
			if (!name) {
				if (windowLoaded) {
					this.send("Socket ready");
				} else {
					jQuery(this.send.bind(this, "Socket ready"));
				}
			}
		},
		send: function (message) {
			const json = this.serialize(message);
			this.target_window.writeAttribute({
				src: `${this.get_src()}#${encodeURIComponent(json)}`,
			});
			setTimeout(() => {
				this.target_window.setStyle({
					height: this.target_window.getHeight() > 50 ? "50px" : "100px",
				});
			}, 0);
		},
		serialize: function (message) {
			return JSON.stringify({
				data: { message: message, channel: channel },
				origin: this.origin,
			});
		},
		get_target_window: function () {
			const iframe = jQuery(`${"<iframe" +
				" src="}${this.get_src()
			} frameborder="0"` +
				" scrolling=\"no\"" +
				" width=\"50\"" +
				" height=\"50\"" +
				" style=\"position:absolute;top:-999px;left:0;\"" +
				"></iframe>");
			jQuery(document.body).append(iframe);
			return iframe;
		},
		get_src: function () {
			return name ? `${proxy}?name=${name}` : proxy;
		},
	};

	if (has_postMessage) {
		base = {
			...base,
			...modern,
		};
	} else {
		base = {
			...base,
			...legacy,
		};
	}
	base.init();

	return base;
};

/*
	Port.proxy is the man in the middle when messaging across
	domains using the legacy iframe proxy technique. Port.proxy
	has an internal send method similar to Port.socket, except that
	it's bound to the window resize event. When triggered, it will
	decode its own src attribute's hash, and pass it along to an
	agreed upon function inside of each parent's Port object.
*/

Port.proxy = {
	listeners: [],
	init: function (name) {
		jQuery(window).on("resize", this.send.bind(this));
		this.target_window = this.get_target_window(name);
	},
	send: function () {
		if (window.location.hash.length > 0) {
			const json = this.serialize(window.location.hash.replace(/^#/, ""));
			this.target_window.Port.proxy.receive(json);
		}
	},
	receive: function (message) {
		for (let i = 0; i < this.listeners.length; i++) {
			this.listeners[i](message);
		}
	},
	serialize: function (message) {
		const json = JSON.parse(decodeURIComponent(message));
		json.data = JSON.stringify(json.data);
		return json;
	},
	get_target_window: function (name) {
		return name ? window.top.frames[name] : window.top;
	},
};

Port.detect = {
	is_host_method: function (obj, method) {
		const type = typeof obj[method];
		return type === "function" || (type === "object" && !!obj[method]);
	},
	is_host_property: function (obj, prop) {
		return prop in obj;
	},
	postMessage: function () {
		return this.is_host_method(window, "postMessage") &&
				this.is_host_property(window, "onmessage");
	},
};



// WEBPACK FOOTER //
// ./src/legacy/port.js